<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import layer from "vue-layer";
import "vue-layer/lib/vue-layer.css";

Vue.prototype.$layer = layer(Vue);
export default {
  name: "App",
};
</script>

<style>
.ivu-table {
  color: #000 !important;
  font-size: 14px !important;
}

body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
li,
ul,
p,
div,
body,
html,
table {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  overflow: hidden;
}
li {
  list-style: none;
}
#app {
  height: 100%;
}
.view-c {
  height: 100%;
  overflow: auto;
}
</style>
